import { ShareContactDetails } from '@/feature/observatory'

import { Organization } from '@/lib/core/interfaces/organization.types'
import { User } from '@/lib/core/interfaces/user.types'

import { Asset, BridgeStatus } from '@/lib/features/Assets/interfaces'

import styles from './VehicleDetailsTooltip.module.css'

export type VehicleDetailsTooltipProps = Pick<Asset, 'plateNumber' | 'make' | 'model' | 'id'> & {
  organization?: Organization
  contactFrom?: User
  contactTo?: User
  bridgeStatus?: BridgeStatus
}

export const VehicleDetailsTooltip = ({
  make,
  model,
  plateNumber,
  id,
  organization,
  contactFrom,
  contactTo,
  bridgeStatus,
}: VehicleDetailsTooltipProps) => (
  <div className={styles.container}>
    <div className={styles.description}>
      Vehicle License Plate:{' '}
      <div className={(plateNumber?.length ?? 0 > 40) ? styles.value : styles.valueLong}>
        {plateNumber}
      </div>
    </div>

    <div className={styles.description}>
      Vehicle Make and Model:{' '}
      <div className={`${make} ${model}`.length > 40 ? styles.value : styles.valueLong}>
        {make} {model}
      </div>
    </div>

    <ShareContactDetails
      assetId={id}
      organization={organization}
      contactFrom={contactFrom}
      contactTo={contactTo}
      bridgeStatus={bridgeStatus}
    />
  </div>
)
